import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

// Utils
import { getElementId } from '../../../../../common/elements/utils/elementPropertyUtils';
import { getMainEditorId, getMainEditorKey } from '../../../../element/utils/elementEditorUtils';

// Actions
import { updateSelectedElements } from '../../../../element/actions/elementActions';
import { startEditingElementWithDelay } from '../../../../element/selection/selectionActions';

// Selectors
import { getShowTitle } from '../../../../element/taskList/taskListSelector';

// Components
import ToolbarTool from '../../commonComponents/ToolbarTool';
import Icon from '../../../../components/icons/Icon';

// Constants
import { SHOW_TITLE_PROPERTY } from '../../../../../common/taskLists/taskListConstants';

const mapStateToProps = (state, ownProps) => ({
    isActive: getShowTitle(ownProps.selectedElements.first()),
});

const mapDispatchToProps = (dispatch, ownProps) => ({
    onPointerDown: (event) => {
        const showingTitle = getShowTitle(ownProps.selectedElements.first());
        const changes = { [SHOW_TITLE_PROPERTY]: !showingTitle };
        dispatch(updateSelectedElements({ changes }));

        if (!showingTitle && ownProps.selectedElements.size === 1) {
            dispatch(
                startEditingElementWithDelay({
                    id: getElementId(ownProps.selectedElements.first()),
                    editorId: getMainEditorId({ element: ownProps.selectedElements.first() }),
                    editorKey: getMainEditorKey({ element: ownProps.selectedElements.first() }),
                    editDelay: 0,
                }),
            );
        }
    },
});

const TitleTool = (props) => (
    <ToolbarTool {...props} name={props.name} isActive={props.isActive}>
        <Icon name="toolbar-title" />
    </ToolbarTool>
);

TitleTool.propTypes = {
    name: PropTypes.string,
    isActive: PropTypes.bool,
};

export default connect(mapStateToProps, mapDispatchToProps)(TitleTool);
